import { type ReactNode } from 'react';

import { ZgriPermissionGuard } from './zgri-permission.guard';

type ZgriFeatureGuardProps = {
  children: ReactNode;
  redirectTo?: string;
};

export function ZgriFeatureGuard({ children, redirectTo }: ZgriFeatureGuardProps) {
  if (redirectTo) {
    return (
      <ZgriPermissionGuard
        require={'user.zgri.use-landlord-features'}
        variant="redirect"
        redirectTo={redirectTo}
      >
        {children}
      </ZgriPermissionGuard>
    );
  }

  return (
    <ZgriPermissionGuard require={'user.zgri.use-landlord-features'}>
      {children}
    </ZgriPermissionGuard>
  );
}
